<template>
  <md-card class="md-card-stats">
    <div
      style="
        display: flex;
        justify-content: space-between;
        padding: 7px 0px 0px;
        border: solid 1px;
        border-color: #8cc63f;
        border-radius: 10px;
        width: 60px;
        height: 60px;
      "
    >
      <div
        style="
          min-width: 100%;
          margin: 0;
          display: flex;
          align-items: center;
          flex-direction: column;
        "
      >
        <slot name="image"></slot>
        <slot class="category" name="title"></slot>
      </div>
    </div>
  </md-card>
</template>
<script>
export default {
  name: "investor-dashboard-mobile-card",
  props: {
    headerColor: {
      type: String,
      default: "",
    },
  },
  methods: {
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Cards/InvestorDashboardMobileCard.vue